module.exports = __webpack_public_path__ + "static/img/atitle2.6b56f9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/atitle2.png
// module id = bAtm
// module chunks = 1